import {loop, Effects} from 'redux-loop';
import {
  TOGGLE_SIDEBAR,
  TOGGLE_ME_SETTING,
  TOGGLE_CLIPPING_PANEL,
} from './actions';

export const initialState = {
  isCollapsed: false,
  isMeSetting: false,
  isShowClippingPanel: false
};

export default (state = initialState, action) => {
  if (action.type === TOGGLE_SIDEBAR) {
    return loop({
      ...state,
      isCollapsed: (action.data === undefined) ? !state.isCollapsed : action.data,
    },
      Effects.none()
    );
  };

  if (action.type === TOGGLE_ME_SETTING) {
    return loop({
      ...state,
      isMeSetting: action.data,
    },
      Effects.none()
    );
  };

  if (action.type === TOGGLE_CLIPPING_PANEL) {
    return loop({
      ...state,
      isShowClippingPanel: (action.data === undefined) ? !state.isShowClippingPanel : action.data,
    },
      Effects.none()
    );
  };

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/reducer.js
 **/